import { defineMessages } from 'react-intl';

/** Short labels for each clinical suggestion category (shared by filters and evidence settings). */
export const suggestionCategoryLabelMessages = defineMessages({
  red_flag: {
    defaultMessage: 'Safety warnings',
    id: 'Dmvj5M1NQl',
    description: 'Category filter label for urgent safety-related suggestion chips',
  },
  suggested_question: {
    defaultMessage: 'Questions to ask',
    id: 'Jkl9czz/pg',
    description: 'Category filter label for patient history or interview question chips',
  },
  examination: {
    defaultMessage: 'Exam findings',
    id: 'jLhF78/px9',
    description: 'Category filter label for physical examination suggestion chips',
  },
  symptom_exploration: {
    defaultMessage: 'Symptom exploration',
    id: '1fS+MPYXFh',
    description: 'Category filter label for symptom differential and exploration chips',
  },
  condition: {
    defaultMessage: 'Condition',
    id: 'Njc7t02EZ/',
    description: 'Category filter label for condition-specific suggestion chips',
  },
  investigation: {
    defaultMessage: 'Suggested workup',
    id: 'gTff7ZJzNb',
    description: 'Category filter label for tests and investigations suggestion chips',
  },
  plan: {
    defaultMessage: 'Treatment planning',
    id: 'skfIlTSi6b',
    description: 'Category filter label for management and treatment suggestion chips',
  },
  clinical_review: {
    defaultMessage: 'Clinical review',
    id: 'moy/7mGjGV',
    description:
      'Category filter label for clinical trajectory and review suggestion chips',
  },
  document_draft: {
    defaultMessage: 'Document drafts',
    id: 'hiI/KOSX8o',
    description:
      'Category label for document-drafting chips from clinical tasks (peek sheet experiment)',
  },
});
